import { useLocation } from 'react-router-dom';
import { Card, Typography } from 'antd';
import EmptyState from '../components/EmptyState';

/**
 * Placeholder for routes whose pages arrive in later phases (calls, dashboard, review queue,
 * reports). Keeps role-based landing and navigation fully functional now.
 */
export default function ComingSoon({ title }: { title?: string }) {
  const location = useLocation();
  return (
    <Card>
      <Typography.Title level={4}>{title ?? 'این بخش'}</Typography.Title>
      <EmptyState description={`این صفحه (${location.pathname}) در فازهای بعدی توسعه پیاده‌سازی می‌شود.`} />
    </Card>
  );
}
